import { performCmdbGetRequest } from '@atlassian/jira-servicedesk-cmdb-client/src/fetch.tsx';
import { getCmdbRestBaseUrl } from '@atlassian/jira-servicedesk-cmdb-rest-urls/src/common/constants/index.tsx';
import { fireCmdbErrorAnalytics } from '@atlassian/jira-servicedesk-cmdb-error-handling/src/fireCmdbErrorAnalytics.tsx';
import type { ActionApi, InstantiatedBundle } from '../../common/types.tsx';

export const fetchCdm =
	(): ActionApi =>
	async ({ setState, getState }, { workspaceId }) => {
		// First reset state to undefined to indicate loading
		const initialState = getState();
		setState({
			...initialState,
			cdm: {
				...initialState.cdm,
				instantiations: undefined, // Reset to undefined while loading
			},
		});

		let instantiationsResponse: InstantiatedBundle[];
		try {
			const apiResponse = await performCmdbGetRequest(
				`${getCmdbRestBaseUrl(workspaceId)}/bundle/instantiated/list`,
			);

			instantiationsResponse = apiResponse?.instantiations || [];
		} catch (error) {
			fireCmdbErrorAnalytics({
				error: error instanceof Error ? error : new Error('Unknown error'),
				meta: {
					id: 'fetchInstantiations',
					packageName: 'jiraServicedeskInsightGlobalConfigurationStore',
					teamName: 'aurum',
				},
			});

			// TODO(KKT-103) : handle error scenario by surfacing it to the user or retrying
			instantiationsResponse = [];
		}

		const state = getState();

		setState({
			...state,
			cdm: {
				...state.cdm,
				instantiations: instantiationsResponse,
			},
		});
	};
